import { storage } from './storage.js';
import { catalog } from './catalog.js';
import { normalizeText, cleanName } from './utils.js';

/* Historial de búsquedas (por proveedor y espectador) y sugerencias al escribir:
   búsquedas anteriores que contienen lo tecleado + títulos del catálogo que empiezan por ello. */

const MAX = 15;

function key() {
    return 'searchHistory:' + catalog.userKey;
}

export const searchHistory = {
    list() {
        const l = storage.get(key(), []);
        return Array.isArray(l) ? l : [];
    },

    add(q) {
        q = String(q || '').trim();
        if (q.length < 2) return;
        const nq = normalizeText(q);
        const l = this.list().filter((x) => normalizeText(x) !== nq);
        l.unshift(q);
        storage.set(key(), l.slice(0, MAX));
    },

    remove(q) {
        const nq = normalizeText(q);
        storage.set(key(), this.list().filter((x) => normalizeText(x) !== nq));
    },

    clear() {
        storage.set(key(), []);
    },

    /**
     * Sugerencias para lo tecleado: { type: 'history'|'vod'|'series'|'live', text, id? }.
     * Con menos de 2 caracteres solo devuelve historial.
     */
    suggest(q, limit = 8) {
        const nq = normalizeText(q || '');
        const hist = this.list()
            .filter((h) => !nq || normalizeText(h).indexOf(nq) !== -1)
            .slice(0, nq ? 4 : limit)
            .map((text) => ({ type: 'history', text }));
        if (nq.length < 2) return hist;
        const seen = new Set(hist.map((h) => normalizeText(h.text)));
        const titles = [];
        for (const kind of ['vod', 'series', 'live']) {
            const items = catalog.visible(kind);
            for (let i = 0; i < items.length && hist.length + titles.length < limit; i++) {
                const it = items[i];
                const s = it._s || normalizeText(it.name);
                if (s.indexOf(nq) !== 0 && s.indexOf(' ' + nq) === -1) continue;
                const name = cleanName(it.name);
                const k = normalizeText(name);
                if (seen.has(k)) continue;
                seen.add(k);
                titles.push({ type: kind, text: name, id: it.id });
            }
        }
        return hist.concat(titles);
    }
};
